import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import API from "@/lib/api";
import { makeT, catName as _catName } from "@/i18n";
import { MACROS as DEFAULT_MACROS } from "@/data/macros";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

function detectLang() {
  const saved = localStorage.getItem("fidate_lang");
  if (saved) return saved;
  const nav = (navigator.language || "it").slice(0, 2);
  return ["it", "en", "de", "fr", "es"].includes(nav) ? nav : "it";
}

export function AppProvider({ children }) {
  const [language, setLanguageState] = useState(detectLang());
  const [country, setCountry] = useState(localStorage.getItem("fidate_country") || "IT");
  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [macros, setMacros] = useState(DEFAULT_MACROS);
  const [macrosLoading, setMacrosLoading] = useState(true);

  useEffect(() => {
    API.get("/countries").then((r) => setCountries(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    API.get(`/categories?country=${country}`).then((r) => setCategories(r.data)).catch(() => {});
    setMacrosLoading(true);
    API.get(`/macros?country=${country}`)
      .then((r) => setMacros(r.data && r.data.length ? r.data : DEFAULT_MACROS))
      .catch(() => setMacros(DEFAULT_MACROS))
      .finally(() => setMacrosLoading(false));
    localStorage.setItem("fidate_country", country);
  }, [country]);

  const setLanguage = (l) => {
    setLanguageState(l);
    localStorage.setItem("fidate_lang", l);
  };

  const t = useMemo(() => makeT(language), [language]);
  const getCategory = (slug) => categories.find((c) => c.slug === slug);
  const getMacro = (id) => macros.find((m) => m.id === id);
  const catName = (cat) => _catName(cat, language);

  return (
    <AppContext.Provider value={{ language, setLanguage, country, setCountry, categories, countries, macros, macrosLoading, t, getCategory, getMacro, catName }}>
      {children}
    </AppContext.Provider>
  );
}
